import LocationSetting from "./KrLocationSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrLocationSetting = install(LocationSetting); // 生成带有 install 方法的组件

export default KrLocationSetting;
